/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { DisplayValuePair } from "./display-value-pair";
import { RequestDto } from "./request-dto";
import { CmpTaskDto } from "./cmp-task-dto";
import { ActivityStreamItemBase } from "./activity-stream-item-base";

export class TaskDetailsScreenDataDto {
    assignedToUsers: DisplayValuePair<string>[] = [];
    request: RequestDto;
    task: CmpTaskDto;
    activityStream: ActivityStreamItemBase[] = [];
}
